// Generated by `pnpm generate:modules` from modules/catalogue.json. Do not edit.

import { siteBrowserModule } from "@amtana/site-browser/declaration";

export const browserModules = [siteBrowserModule] as const;
